export default __webpack_public_path__ + "static/benefitImg-0a957660e2a85c135d074251861e900b.png";